export default __webpack_public_path__ + "static/media/materialui.518da2c0.svg";